import "leaflet/dist/leaflet.css";
import "./styles.css";
import { SensorDataProps } from "../../../controller/tankController";
import {
  MdOutlineWater,
  MdOutlineSensors,
  MdOutlineDateRange,
} from "react-icons/md";
import { FiVolume } from "react-icons/fi";
import { GiWaterTank, GiEnergyTank, GiFuelTank } from "react-icons/gi";
import { WiHumidity } from "react-icons/wi";
import { CiTempHigh } from "react-icons/ci";
import { TbWashTemperature3 } from "react-icons/tb";
import { TbBattery4 } from "react-icons/tb";
import { TankProps } from "../../../assets/SampleData/TankData";
import { formatTimeAgo } from "../../../hooks/updatedTime";

interface TankDetailsProps {
  showTankDetails: boolean;
  setShowTankDetails: (value: boolean) => void;
  tankSensorDetails?: SensorDataProps;
  tankSize?: string;
  tankId?: string;
  tankDetails?: TankProps;
}
function TankDetails(props: TankDetailsProps) {
  function getTankStatus(tankLevel: string | number | undefined): string {
    if (tankLevel === undefined) return "Nil";

    const level = Number(tankLevel);

    if (level < 40) return "Low";
    if (level >= 40 && level <= 50) return "Average";
    if (level > 50 && level <= 70) return "Moderate";
    if (level > 70) return "Good";

    return "Nil";
  }

  const currentLevel = Number(props.tankSensorDetails?.tankLevel);

  const TANK_HEIGHT = 110.3;
  const RADIUS = 38.3;
  const currentHeight = (currentLevel / 100) * TANK_HEIGHT;
  const currentVolume = (
    (Math.PI * Math.pow(RADIUS, 2) * currentHeight) /
    1000
  ).toFixed(1);

  return (
    <div className="bin-details-wrapper">
      <div className="bin-details">
        <div className="close-div">
          <img
            src="./images/user/close.svg"
            alt="close"
            onClick={() => {
              props.setShowTankDetails(false);
            }}
            className="close-iccon"
          />
        </div>
        <div className="tank-details-content">
          <div className="tank-full-details">
            <div className="trash-div">
              <div className="trash-img">
                <img src="./images/tankdetails/tankstat.svg" alt="tank" />
              </div>
            </div>
            <h2 className="bin-details-heading" id="tank-heading">
              Tank Details ({props.tankId})
            </h2>
            <div className="tankstat-div">
              <h3 className="stat-details" id="tank-stat-details">
                Diesel Level & Tank Status
              </h3>
              <div className="tankstat-cont">
                <div className="tankstat-details" id="tankstat-details">
                  <MdOutlineWater size={24} color="#6e9be3" />
                  <img src='./images/tankdetails/orientation.svg"' alt="" />
                  <p>
                    Diesel height:{" "}
                    {props.tankSensorDetails?.tankLevel
                      ? `${props.tankSensorDetails?.tankLevel}%`
                      : "Nil"}
                  </p>
                </div>
                <div className="tankstat-details" id="tankstat-details">
                  <FiVolume size={24} color="#6e9be3" />
                  <img src='./images/tankdetails/orientation.svg"' alt="" />
                  <p>
                    Diesel volume:{" "}
                    {currentLevel ? `${currentVolume}Litres` : "Nil"}
                  </p>
                </div>
                <div className="tankstat-details" id="tankstat-details">
                  <GiWaterTank size={24} color="#6e9be3" />
                  <img src='./images/tankdetails/orientation.svg"' alt="" />
                  <p>
                    Tank fullness:{" "}
                    {TANK_HEIGHT}Cm
                  </p>
                </div>
                <div className="tankstat-details" id="tankstat-details">
                  <GiEnergyTank size={24} color="#6e9be3" />
                  <img src='./images/tankdetails/orientation.svg"' alt="" />
                  <p>
                    Tank status:{" "}
                    {getTankStatus(props.tankSensorDetails?.tankLevel)}
                  </p>
                </div>
                <div className="tankstat-details" id="tankstat-details">
                  <GiFuelTank size={24} color="#6e9be3" />
                  <img src='./images/tankdetails/orientation.svg"' alt="" />
                  <p>
                    Tank orientation:{" "}
                    {props.tankSensorDetails?.tankOrientation
                      ? `${props.tankSensorDetails?.tankOrientation}`
                      : "Nil"}
                  </p>
                </div>
                <div className="tankstat-details" id="tankstat-details">
                  <MdOutlineDateRange size={24} color="#6e9be3" />
                  <img src='./images/tankdetails/orientation.svg"' alt="" />
                  <p>
                    Last Updated:{" "}
                    {formatTimeAgo(props.tankSensorDetails?.createdAt)}
                  </p>
                </div>
              </div>
            </div>
            <div className="tankstat-div">
              <h3 className="stat-details" id="tank-stat-details">
                Environmental Conditions
              </h3>
              <div className="tankstat-cont">
                <div className="tankstat-details" id="tankstat-details">
                  <TbWashTemperature3 size={24} color="#6e9be3" />
                  <img src='./images/tankdetails/orientation.svg"' alt="" />
                  <p>
                    Diesel temperature:{" "}
                    {props.tankSensorDetails?.tankTemperaure
                      ? `${props.tankSensorDetails?.tankTemperaure}°C`
                      : "Nil"}
                  </p>
                </div>
                <div className="tankstat-details" id="tankstat-details">
                  <CiTempHigh size={24} color="#6e9be3" />
                  <img src='./images/tankdetails/orientation.svg"' alt="" />
                  <p>
                    Ambient temperature:{" "}
                    {props.tankSensorDetails?.ambientTemperature
                      ? `${props.tankSensorDetails?.ambientTemperature}°C`
                      : "Nil"}
                  </p>
                </div>
                <div className="tankstat-details" id="tankstat-details">
                  <WiHumidity size={24} color="#6e9be3" />
                  <img src='./images/tankdetails/orientation.svg"' alt="" />
                  <p>
                    Ambient humidity:{" "}
                    {props.tankSensorDetails?.ambientHumidity
                      ? `${props.tankSensorDetails?.ambientHumidity}%`
                      : "Nil"}
                  </p>
                </div>
              </div>
            </div>
            <div className="tankstat-div">
              <h3 className="stat-details" id="tank-stat-details">
                System & Sensor Health
              </h3>
              <div className="tankstat-cont">
                <div className="tankstat-details" id="tankstat-details">
                  <MdOutlineSensors size={24} color="#6e9be3" />
                  <img src='./images/tankdetails/orientation.svg"' alt="" />
                  <p>
                    Ultrasonic sensor status:{" "}
                    {props.tankSensorDetails?.waterHeight
                      ? `${props.tankSensorDetails?.waterHeight}cm`
                      : "Nil"}
                  </p>
                </div>
                <div className="tankstat-details" id="tankstat-details">
                  <TbBattery4 size={24} color="#6e9be3" />
                  <img src='./images/tankdetails/orientation.svg"' alt="" />
                  <p>
                    Battery level:{" "}
                    {props.tankSensorDetails?.batteryLevel
                      ? `${props.tankSensorDetails?.batteryLevel}%`
                      : "Nil"}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TankDetails;
